import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/no-array-index-key */

/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '@sainsburys-tech/boltui-utils';
import * as Styled from './FilterPills.styles';

var FilterPills = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterPills, _React$Component);

  var _super = _createSuper(FilterPills);

  function FilterPills(props) {
    var _this;

    _classCallCheck(this, FilterPills);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "animatePills", function (pillIndex) {
      var dataTest = _this.props['data-test'];
      var domPills = window.document.querySelectorAll("[data-test^=".concat(dataTest, "-pill]")); // not using refs so that Pill can be functional

      if (!isEmpty(domPills)) {
        var pills = _toConsumableArray(domPills);

        var offsets = _this.getDomPillOffsets(pills, pillIndex);

        pills.forEach(function (ta, index) {
          _this.animateTranslateXToZero(ta, offsets[index]);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getDomPillOffsets", function (domPills, pillIndexToToggle) {
      var pillToToggle = domPills[pillIndexToToggle];

      var startPositions = _this.mapToLeftOffset(domPills);

      pillToToggle.style.order = pillToToggle.style.order === '-1' ? '0' : '-1';

      var endPositions = _this.mapToLeftOffset(domPills);

      return startPositions.map(function (startPosition, index) {
        return startPosition - endPositions[index];
      });
    });

    _defineProperty(_assertThisInitialized(_this), "mapToLeftOffset", function (pills) {
      return pills.map(function (pill) {
        return pill.offsetLeft;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "animateTranslateXToZero", function (pill, offset) {
      if (offset && Math.abs(offset) > 0.1) {
        pill.style.transform = "translateX(".concat(offset, "px)");
        window.requestAnimationFrame(function () {
          return _this.animateTranslateXToZero(pill, offset * 0.8);
        });
      } else {
        pill.style.transform = null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function (pill, index, event) {
      if (pill.href) return;
      var _this$props = _this.props,
          isAnimated = _this$props.isAnimated,
          onActivate = _this$props.onActivate,
          onDeactivate = _this$props.onDeactivate;
      var pills = _this.state.pills;
      var updatedPills = pills.map(function (oldPill, oldPillIndex) {
        return index === oldPillIndex ? _objectSpread(_objectSpread({}, oldPill), {}, {
          active: !oldPill.active
        }) : oldPill;
      });

      _this.setState({
        pills: updatedPills
      });

      if (isAnimated) _this.animatePills(index);
      event.preventDefault();
      event.stopPropagation();
      if (pill.active) onDeactivate(pill);
      if (!pill.active) onActivate(pill);
    });

    _this.state = {
      pills: props.pills
    };
    return _this;
  }

  _createClass(FilterPills, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.pills !== this.props.pills) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          pills: this.props.pills
        });
      }
    } // Animation effect

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var pills = this.state.pills;
      var _this$props2 = this.props,
          dataTest = _this$props2['data-test'],
          className = _this$props2.className,
          pillClassName = _this$props2.pillClassName;
      return /*#__PURE__*/React.createElement(Styled.FilterPills, {
        "data-test": dataTest,
        className: className
      }, pills.map(function (pill, index) {
        return /*#__PURE__*/React.createElement(Styled.ListItem, {
          key: index
        }, /*#__PURE__*/React.createElement(Styled.Pill, {
          href: pill.href,
          target: pill.openNewTab ? '_blank' : '_self',
          onClick: function onClick(event) {
            return !pill.disabled && _this2.toggle(pill, index, event);
          },
          label: pill.label,
          active: pill.active,
          disabled: pill.disabled,
          "data-test": "".concat(dataTest, "-pill-").concat(index),
          className: pillClassName
        }));
      }));
    }
  }]);

  return FilterPills;
}(React.Component);

export { FilterPills as default };
FilterPills.propTypes = {
  /**
   * Specify the content of your FilterPills
   */
  pills: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    href: PropTypes.string,
    active: PropTypes.bool,
    openNewTab: PropTypes.bool
  })),

  /**
   * Enable or disable animation effect when interacting with a pill. Defaults to true
   */
  isAnimated: PropTypes.bool,

  /**
   * Optional prop to provide a callback function which is called when a Pill is activated
   */
  onActivate: PropTypes.func,

  /**
   * Optional prop to provide a callback function which is called when a Pill is deactivated
   */
  onDeactivate: PropTypes.func,

  /**
   * Specify an optional data-test attribute to be added to your FilterPills component for e2e testing
   */
  'data-test': PropTypes.string,

  /**
   * Specify an optional className to be added to FilterPills
   */
  className: PropTypes.string,

  /**
   * Specify an optional className to be added to child Pill components
   */
  pillClassName: PropTypes.string
};
FilterPills.displayName = 'FilterPills';
FilterPills.defaultProps = {
  pills: [],
  isAnimated: true,
  onActivate:
  /* istanbul ignore next */
  function onActivate() {},
  onDeactivate:
  /* istanbul ignore next */
  function onDeactivate() {},
  'data-test': 'component-filter-pills',
  className: '',
  pillClassName: ''
};